import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Phase 5 chunk 4 — Workflows route group layout.
 *
 * Thin wrapper that hosts the `<Outlet />` for both the list
 * (`workflows.index.tsx`) and the per-workflow editor surface
 * (`workflows.$workflowId.tsx`).  Reads are open to active team
 * members (governance transparency); mutations are gated server-side
 * by `workflow.admin` scope and surface 403
 * `workflow_scope_forbidden` for non-admins.
 */
export const Route = createFileRoute('/workflows')({
  component: () => <Outlet />,
});
